import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { colDefs, rowData, TdsEntryPopUp } from "./TdsEntryTable";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm } from "../../../utils/validation/CommonValidator";

class TdsEntry extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isModalOpen: false,
            isTable2Expanded: false,
            prop: {},
            table2Data: [],
            table2ColDefs: [],
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            receiptDetails: {
                receiptNo: "",
                paymentDate: "",
                type: [],
                accHead: [],
                fromDate: "",
                toDate: "",
                selectVendor: [],
                tds: "",
                paybleAmount: "",
                tdsAmount: "",
                remarks: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                paymentDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment date"
                        ),
                    },
                ],
                type: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                accHead: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account head"
                        ),
                    },
                ],
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    },
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    },
                ],
                selectVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "select vendor"
                        ),
                    },
                ],
                tds: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "TDS"
                        ),
                    },
                ],
                paybleAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payble amount"
                        ),
                    },
                ],
                tdsAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "TDS amount"
                        ),
                    },
                ],
            }
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "TDS Entry");
        //}
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.procSelectAllRecordsSP();
            });
        } else {
            // window.location.href = "/Login";
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "TDS Entry",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                        field: key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        flex: 1
                    }));
                    var colName = dynamicColDefs[0].field;
                    let id = data ? data[0][colName] : 0;
                    this.setState({
                        rowData: data,
                        colDefs: dynamicColDefs,
                        caption: "TDS Entry",
                        colName: colName
                    }, () => {
                        this.procSelectAllRecord2GridviewSP(id, "TDS Entry");
                    });
                }
            }
        });
    };

    onRowDoubleClicked = (event) => {
        this.openPopUpForUpdateItem(event);
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        this.setState({ isModalOpen: true })
    };

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.receiptDetails;
        details[name] = value;
        this.setState({ receiptDetails: details });
    }
    handleSelectChange = (event, name) => {
        let select = event.target.value;
        let details = this.state.receiptDetails;
        details[name] = select;
        this.setState({ receiptDetails: details });
    }

    saveItem = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.receiptDetails;
            if (details !== "") {

                console.log(details);
            } else {
                console.log("Enter valid data")
            }
        } else {
            console.log(this.state.receiptDetails)
            console.log(this.state.validState.error)
        }
        // this.setState({ isModalOpen: !this.state.isModalOpen });

    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.receiptDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        return (
            <div className='journal-voucher'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }} />
                        <TdsEntryPopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            receiptDetails={this.state.receiptDetails}
                            validState={this.state.validState}
                            saveItem={this.saveItem.bind(this)}
                        />
                        <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">TDS entry</h1>
                                </div>
                                <AgGridReact
                                    rowData={rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                />
                            </div>
                        </div>
                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default TdsEntry;